module.exports = __webpack_public_path__ + "static/media/room icon 2.8c251aa4.svg";